import React from 'react'
import { Pressable, Text, View } from 'react-native'

import { circleButton } from '@ui-kit/components/CircleButton/styles'
import { borderColor } from '@ui-kit/styles/colors'

import type { NativeProps } from './types'

const CircleButton = (props: NativeProps): JSX.Element => {
  const { container, circle, text } = circleButton({
    disabled: props.disabled,
  })
  return (
    <Pressable
      className={container()}
      key={props.id}
      testID={props.id}
      onPress={props.disabled ? undefined : props.onPress}
      disabled={props.disabled}
    >
      <View
        className={circle({ className: borderColor({ color: props.borderColor ?? 'uiDark' }) })}
      >
        {props.icon}
      </View>
      {props.label !== undefined ? <Text className={text()}>{props.label}</Text> : null}
    </Pressable>
  )
}

export default CircleButton
